(() => {
  const initCartDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const scrim = document.querySelector('[data-cart-drawer-scrim]');
    const closeButton = drawer?.querySelector('[data-cart-drawer-close]');
    const lines = drawer?.querySelector('[data-cart-drawer-lines]');
    const footer = drawer?.querySelector('[data-cart-drawer-footer]');
    const subtotal = drawer?.querySelector('[data-cart-drawer-subtotal]');
    const countrySelect = drawer?.querySelector('[data-cart-country-select]');
    const countryStatus = drawer?.querySelector('[data-cart-country-status]');
    const openButtons = Array.from(document.querySelectorAll('[data-cart-drawer-open]'));

    if (!drawer || !scrim || !closeButton || !lines || !footer || !subtotal || !openButtons.length) return;

    let lastFocused = null;
    let hideTimer = null;

    const money = (minorUnits, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: currency || 'GBP'
        }).format((minorUnits || 0) / 100);
      } catch (error) {
        return `£${((minorUnits || 0) / 100).toFixed(2)}`;
      }
    };

    const setCounts = (count) => {
      document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach((element) => {
        element.textContent = String(count);
      });
      document.querySelectorAll('[data-cart-drawer-count-label]').forEach((element) => {
        element.textContent = count === 1 ? 'service' : 'services';
      });
    };

    const textElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      element.textContent = text;
      return element;
    };

    const renderEmpty = () => {
      lines.replaceChildren();
      const empty = textElement('div', 'cart-drawer-empty', 'Your repair cart is empty.');
      const link = textElement('a', '', 'Browse repairs ↗');
      link.href = '/pages/repairs';
      empty.appendChild(document.createElement('br'));
      empty.appendChild(link);
      lines.appendChild(empty);
      footer.hidden = true;
    };

    const renderItem = (item, currency) => {
      const row = document.createElement('article');
      row.className = 'cart-drawer-line';

      if (item.image) {
        const imageLink = document.createElement('a');
        imageLink.className = 'cart-drawer-line-image';
        imageLink.href = item.url || drawer.dataset.cartPageUrl;
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        imageLink.appendChild(image);
        row.appendChild(imageLink);
      } else {
        const imagePlaceholder = document.createElement('span');
        imagePlaceholder.className = 'cart-drawer-line-image';
        imagePlaceholder.setAttribute('aria-hidden', 'true');
        row.appendChild(imagePlaceholder);
      }

      const copy = document.createElement('div');
      copy.className = 'cart-drawer-line-copy';
      const title = textElement('a', 'cart-drawer-line-title', item.product_title || item.title || 'Repair service');
      title.href = item.url || drawer.dataset.cartPageUrl;
      copy.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        copy.appendChild(textElement('span', 'cart-drawer-line-meta', item.variant_title));
      }
      copy.appendChild(textElement('span', 'cart-drawer-line-meta', `Quantity ${item.quantity}`));
      const removeButton = textElement('button', 'cart-drawer-line-remove', 'Remove');
      removeButton.type = 'button';
      removeButton.dataset.cartLineRemove = '';
      removeButton.dataset.cartLineKey = item.key;
      removeButton.setAttribute('aria-label', `Remove ${item.product_title || item.title || 'repair service'} from cart`);
      copy.appendChild(removeButton);
      row.appendChild(copy);
      row.appendChild(textElement('strong', 'cart-drawer-line-price', money(item.final_line_price, currency)));

      return row;
    };

    const renderCart = (cart) => {
      setCounts(cart.item_count || 0);
      if (!cart.items || !cart.items.length) {
        renderEmpty();
        return;
      }

      lines.replaceChildren();
      cart.items.forEach((item) => lines.appendChild(renderItem(item, cart.currency)));
      subtotal.textContent = money(cart.total_price, cart.currency);
      footer.hidden = false;
    };

    const loadCart = async () => {
      lines.replaceChildren(textElement('p', 'cart-drawer-loading', 'Loading your cart…'));
      try {
        const response = await fetch(drawer.dataset.cartStateUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart request failed');
        renderCart(await response.json());
      } catch (error) {
        footer.hidden = true;
        const message = textElement('div', 'cart-drawer-error', 'The cart could not be loaded.');
        const link = textElement('a', '', 'Open the full cart ↗');
        link.href = drawer.dataset.cartPageUrl;
        message.appendChild(document.createElement('br'));
        message.appendChild(link);
        lines.replaceChildren(message);
      }
    };

    const openDrawer = (trigger) => {
      if (hideTimer) window.clearTimeout(hideTimer);
      lastFocused = trigger || document.activeElement;
      drawer.hidden = false;
      scrim.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('cart-drawer-open');
      window.requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        scrim.classList.add('is-open');
        closeButton.focus();
      });
      loadCart();
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('cart-drawer-open');
      hideTimer = window.setTimeout(() => {
        drawer.hidden = true;
        scrim.hidden = true;
      }, 330);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openDrawer(button);
      });
    });
    closeButton.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);

    lines.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;
      const removeButton = event.target.closest('[data-cart-line-remove]');
      if (!(removeButton instanceof HTMLButtonElement) || !removeButton.dataset.cartLineKey) return;

      removeButton.disabled = true;
      removeButton.textContent = 'Removing…';

      try {
        const response = await fetch(drawer.dataset.cartChangeUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: removeButton.dataset.cartLineKey, quantity: 0 })
        });
        if (!response.ok) throw new Error('Unable to remove cart item');
        renderCart(await response.json());
      } catch (error) {
        removeButton.disabled = false;
        removeButton.textContent = 'Try again';
      }
    });

    countrySelect?.addEventListener('change', () => {
      try {
        window.sessionStorage.setItem('part92-reopen-cart-drawer', 'true');
      } catch (error) {
        // The country selection still works if storage is unavailable.
      }
      const countryInput = countrySelect.form?.querySelector('[data-cart-country-input]');
      if (countryInput instanceof HTMLInputElement) countryInput.value = countrySelect.value;
      countrySelect.disabled = true;
      if (countryStatus) countryStatus.textContent = 'Updating country, prices and currency…';
      countrySelect.form?.submit();
    });

    document.addEventListener('keydown', (event) => {
      if (drawer.hidden || drawer.getAttribute('aria-hidden') === 'true') return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    try {
      if (window.sessionStorage.getItem('part92-reopen-cart-drawer') === 'true') {
        window.sessionStorage.removeItem('part92-reopen-cart-drawer');
        openDrawer(openButtons[0]);
      }
    } catch (error) {
      // No action is needed if storage is unavailable.
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer, { once: true });
  } else {
    initCartDrawer();
  }
})();
